import { Box } from '@mui/material';
import { FC, SyntheticEvent } from 'react';
import Carousel from '../../../elements/Carousel/Carousel';
import useOxTabs from '../../../elements/OxTabs/hooks/useOxTabs';
import PaginationDots from '../../../elements/PaginationDots/PaginationDots';
import SlidingPanel from '../../../elements/SlidingPanel/SlidingPanel';
import SkeletonLoader from '../../../executive-summary/components/SkeletonLoader';
import { Issue } from '../../../issues/common/types/issues-types';
import { topIssuesToolTipInfo } from '../../utils/create-issues-info';
import DashboardSecToolsIssues from '../DashboardSecToolsIssues/DashboardSecToolsIssues';

const DashboardIssuesPanel: FC<
  React.PropsWithChildren<DashboardIssuesPanelProps>
> = ({
  topIssues,
  handleChangeTopIssues,
  topIssuesCategory,
  categories,
  loadingIssues,
  loadingMessage,
}) => {
  const { handleTabChange, tabIndex } = useOxTabs();

  const handleChange = (
    _: SyntheticEvent<Element, Event>,
    newValue: number,
  ) => {
    handleChangeTopIssues(categories[newValue]);
    handleTabChange(_, newValue);
  };

  if (loadingIssues) {
    return <SkeletonLoader loading={loadingIssues} message={loadingMessage} />;
  }

  if (!topIssues?.length) return null;

  return (
    <Box height='100%' pb={1}>
      <Carousel tabIndex={tabIndex} onChange={handleChange}>
        {categories.map((category, indexCategory) => {
          return (
            <SlidingPanel
              key={indexCategory}
              index={indexCategory}
              activeIndex={tabIndex}>
              <DashboardSecToolsIssues
                topIssues={topIssuesCategory}
                tabLabel={`Top 5 ${category} issues`}
                title={topIssuesToolTipInfo.get(category)}
                category={category}
              />
            </SlidingPanel>
          );
        })}
      </Carousel>
      <PaginationDots activeIndex={tabIndex} dots={categories.length} />
    </Box>
  );
};

export interface DashboardIssuesPanelProps {
  topIssues: Issue[];
  handleChangeTopIssues: (categoryName: string) => void;
  topIssuesCategory: Issue[];
  categories: string[];
  loadingIssues: boolean;
  loadingMessage?: string;
}

export default DashboardIssuesPanel;
